import React from 'react';

const DsConnectedView = () => {
  return (
    <div>
      Please wait. Redirecting you back to your form.
    </div>
  );
};

export default DsConnectedView;